import { IFetchCommercialBreadcrumbsParameters } from './types';
import { ResponseError } from '../../errors';
import { ICommercialBreadcrumbs } from '../../types/commercialBreadcrumbs';
import { prepareCommercialBreadcrumbs } from '../../mappers/prepareCommercialBreadcrumbs';
import {
  EQueryParameters,
  fetchGetBreadcrumbs,
  IGetBreadcrumbsRequest,
  TGetBreadcrumbsResponse,
} from '../../repositories/seo-sections/v1/get-breadcrumbs';
import { IApplicationContext } from '../../types/applicationContext';

export async function fetchCommercialBreadcrumbs(
  context: IApplicationContext,
  { subdomain, path }: IFetchCommercialBreadcrumbsParameters,
): Promise<ICommercialBreadcrumbs | null> {
  const { httpApi } = context;
  const { uri, query } = splitPath(path);

  const parameters: IGetBreadcrumbsRequest = {
    subdomain,
    offerType: EQueryParameters.Commercial,
    ...(uri ? { uri } : null),
    ...(query ? { query } : null),
  };

  const breadcrumbs: TGetBreadcrumbsResponse = await fetchGetBreadcrumbs({ httpApi, parameters });

  if (breadcrumbs.statusCode !== 200) {
    throw new ResponseError({
      domain: 'fetchCommercialBreadcrumbs',
      message: breadcrumbs.response.message || '',
      details: {
        error: JSON.stringify(breadcrumbs.response.errors),
      },
    });
  }

  return prepareCommercialBreadcrumbs(breadcrumbs.response);
}

function splitPath(pathOrUrl: string): { uri: string; query: string } {
  const path = toRelativePath(pathOrUrl);
  const queryIndex = path.indexOf('?');
  const pathname = queryIndex === -1 ? path : path.slice(0, queryIndex);
  const query = queryIndex === -1 ? '' : path.slice(queryIndex + 1);

  return {
    uri: pathname.startsWith('/cat.php') ? '' : breadcrumbsApiUri(pathname),
    query,
  };
}

function toRelativePath(pathOrUrl: string): string {
  try {
    const { pathname, search } = new URL(pathOrUrl);

    return `${pathname}${search}`;
  } catch {
    return pathOrUrl;
  }
}

function breadcrumbsApiUri(uri: string): string {
  if (!uri) {
    return uri;
  }

  return uri.endsWith('/') ? uri : `${uri}/`;
}
